<template>
  <div>
    <a-card class="customer-filter" title="超时通知规则">
      <a-button type="primary" style="margin-bottom: 16px" @click="addRow">新增规则</a-button>
      <a-table size="middle" :columns="columns" :data-source="overTimeNewConfig" row-key="level">
        <span slot="customKey" slot-scope="text, record">
          <span>{{ record.level }}</span>
        </span>
        <span slot="time" slot-scope="text, record">
          <a-input-number v-model="record.time" :min="0" :max="24" :step="0.1" @change="modifyConfig" />
        </span>
        <span slot="user" slot-scope="text, record">
          <a-select v-model="record.user" show-search mode="multiple" placeholder="工单责任人" :filter-option="utils.filterOption" style="width: 240px" @change="modifyConfig">
            <a-select-option v-for="(user, index) in userList" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
          </a-select>
        </span>
        <span slot="method" slot-scope="text, record">
          <a-checkbox v-model="record.method.feishu">飞书</a-checkbox>
        </span>
        <span slot="type" slot-scope="text, record">
          <a-select v-model="record.type" mode="multiple" allow-clear placeholder="工单类型" style="width: 240px" @change="modifyConfig">
            <a-select-option v-for="(item, index) in ticektType" :key="index" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { modifyTicketConfig } from '@/api/event/problem';
import { ticektType } from '@/utils/dictionary';
const columns = [
  {
    title: 'ID',
    dataIndex: 'level',
    key: 'level',
    width: 70,
    scopedSlots: { customRender: 'customKey' }
  },
  {
    title: '超时时间(小时)',
    dataIndex: 'time',
    key: 'time',
    width: 70,
    scopedSlots: { customRender: 'time' }
  },
  {
    title: '通知人',
    dataIndex: 'user',
    key: 'user',
    width: 70,
    scopedSlots: { customRender: 'user' }
  },
  {
    title: '工单类型',
    dataIndex: 'type',
    key: 'type',
    width: 240,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '通知方式',
    dataIndex: 'method',
    key: 'method',
    width: 70,
    scopedSlots: { customRender: 'method' }
  }
];
const plainOptions = [
  { label: '飞书', value: 'feishu' },
  { label: '电话', value: 'phonecall' },
  { label: '短信', value: 'message' }
];
export default {
  components: {},
  props: {
    overTimeConfig: {
      type: Array,
      default: null
    },
    userList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      ticektType,
      columns,
      overTimeNewConfig: {}
    };
  },
  computed: {
    checkedMethods(value) {
      return Object.keys(value).filter(key => value[key]);
    }
  },
  created() {
    this.overTimeNewConfig = this.overTimeConfig;
  },
  methods: {
    addRow() {
      const newRecord = {
        level: `${this.overTimeNewConfig.length + 1}`,
        time: 1,
        user: [],
        method: { feishu: true },
        type: []
      };
      this.overTimeNewConfig.push(newRecord);
    },
    modifyConfig() {
      const req = {
        info: this.overTimeNewConfig,
        number: 2
      };
      modifyTicketConfig(req)
        .then(res => {
          this.configData = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
.member-info {
  margin-left: 4px;
}
</style>
